import { automationsRepo } from '@/constants/providers';
import { useMutation } from '@tanstack/react-query';

export const useCreateAutomation = () =>
  useMutation<number, unknown, FormData>((data) =>
    automationsRepo.createAutomation(data),
  );
